import Router from './shared/Routes';

function App() {
  return <Router />;
}

export default App;
